export default __webpack_public_path__ + "static/media/img_bg_transition_green_beige.82fe567b.jpg";